import React from 'react';
import { Route } from 'react-router-dom';
import MoUManagement from '@/pages/mou/MoUManagement';

export const mouRoutes = (
  <React.Fragment>
    <Route path="mou" element={<MoUManagement />} />
    <Route path="mou/list" element={<MoUManagement />} />
    <Route path="mou/activities" element={<MoUManagement />} />
    <Route path="mou/analytics" element={<MoUManagement />} />
  </React.Fragment>
);
